import { Box, Button, Grid, Paper } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'

import React, { FC } from 'react'
import styled from 'styled-components'

const StyledPaper = styled(Paper)`
  width: 100%;
  margin-bottom: 10px;
  padding: 10px;
`

type Props = {
  disabled?: boolean
  handleOpenProductForm: (productId?: string) => () => void
}

const CompanyProductListHandlerBar: FC<Record<string, unknown> & Props> = ({
  disabled = false,
  handleOpenProductForm
}: Props) => {
  return (
    <Grid container style={{ width: '100%' }} alignItems="stretch">
      <StyledPaper>
        <Box display="flex" justifyContent="flex-end">
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={handleOpenProductForm()}
            disabled={disabled}
          >
            Create Product
          </Button>
        </Box>
      </StyledPaper>
    </Grid>
  )
}

export default CompanyProductListHandlerBar
